import React from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { MuiPicker } from '../../MuiPicker'
import CalendarTeacherDropdown from '../CalendarTeacherDropdown/CalendarTeacherDropdown'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import NewPendingOfferStudentCard from './NewPendingOfferStudentCard'

let myToken = localStorage.getItem('token')
let myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

const NewPendingOffer = (props) => {
  const [somethingWasChanged, setSomethingWasChanged] = React.useState(false)

  React.useEffect(() => {
    props.openOffer ?
      axios.get(`${baseUrl}/school-management/school/${props.schoolCalendar.schoolAbbreviation}`, myHeader)
      .then((res) => { props.setSchoolFamilies(res.data) })
      .catch((err) => console.log(err))
    : 
      setSomethingWasChanged(false)
  }, [props.openOffer])

  const changeLessonLength = (value) => {
    props.setNewOfferObject((prev) => ({...prev, lessonLength: value}))
  }

  const tryToDiscard = () => {
    if(somethingWasChanged) {
      props.setDiscardUnsavedChangesPopup(true)
      props.setDiscardType('new-offer')
    } else {
      props.setOpenOffer(false)
      props.setNewOfferObject(false)
    }
  }

  return (
    <Transition.Root show={props.openOffer} as={React.Fragment}>
      <Dialog as="div" className="relative z-10" onClose={tryToDiscard}>
        <div className="fixed inset-0" />
        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
              <Transition.Child as={React.Fragment} enter="transform transition ease-in-out duration-500 sm:duration-700" enterFrom="translate-x-full" enterTo="translate-x-0" leave="transform transition ease-in-out duration-500 sm:duration-700" leaveFrom="translate-x-0" leaveTo="translate-x-full">
                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                  <form className="flex h-full flex-col divide-y rounded-2xl overflow-hidden divide-gray-200 bg-white shadow-xl">
                    <div className="h-0 flex-1 overflow-y-auto">
                      <div className="bg-purple-700 py-6 px-4 sm:px-6">
                        <div className="flex items-center justify-between">
                          <Dialog.Title className="text-lg m-0 font-medium text-white"><input placeholder="New Event" value={props.newEvent.name} onChange={(e) => props.setNewOfferObject({...props.newEvent, name: e.target.value})} className="text-lg m-0 font-medium text-white bg-purple-700 border-none placeholder:text-white" /></Dialog.Title>
                          <div className="ml-3 flex h-7 items-center">
                            <button
                              type="button"
                              className="bg-purple-700 rounded-md  text-white border-none hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                              onClick={() => tryToDiscard()}
                            >
                              <span className="sr-only">Close panel</span>
                              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="flex flex-1 flex-col justify-between">
                        <div className="divide-y divide-gray-200 px-4 sm:px-6">
                          <div className="space-y-6 pt-6 pb-5">
                            <CalendarTeacherDropdown teachers={props.teachers} newEvent={props.newEvent} setNewEvent={props.setNewOfferObject} setSomethingWasChanged={setSomethingWasChanged} />
                            <NewPendingOfferStudentCard newEvent={props.newEvent} setNewOfferObject={props.setNewOfferObject} setFamilySearchOpen={props.setFamilySearchOpen} setSomethingWasChanged={setSomethingWasChanged} />
                            <div className='inline-block mt-5'>
                              <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <MuiPicker setNewEvent={props.setNewOfferObject} newEvent={props.newEvent} setSomethingWasChanged={setSomethingWasChanged} />
                              </LocalizationProvider>
                            </div>
                            <div className='text-left'>
                              <div className='text-sm text-gray-500'>Lesson Length:</div>
                                <select className='w-full p-2 rounded-md border-gray-300 ' onChange={(e) => changeLessonLength(e.target.value)} value={props.newEvent.lessonLength}>
                                  <option value={30}>30 minutes</option>
                                  <option value={60}>1 hour</option>
                                  <option value={90}>1.5 hours</option>
                                  <option value={120}>2 hours</option>
                                  <option value={150}>2.5 hours</option>
                                  <option value={180}>3 hours</option>
                                  <option value={210}>3.5 hours</option>
                                  <option value={240}>4 hours</option>
                                </select>
                            </div>
                            <div className="mt-4 flex text-xs">
                              <div className="ml-2 text-gray-400">Created by {props.userData.Name.split(' ')[0]}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-shrink-0 justify-end px-4 py-4">
                      <button type="button" onClick={() => tryToDiscard()} className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 cursor-pointer">
                        Cancel
                      </button>
                      <div type="submit" onClick={() => props.createCalendarEvent(props.newEvent)} className="ml-4 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 cursor-pointer">
                        Save
                      </div>
                    </div>
                  </form>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
export default NewPendingOffer;